import { render, staticRenderFns } from "./Shortlist.vue?vue&type=template&id=a8cb9cce&scoped=true&"
import script from "./Shortlist.vue?vue&type=script&lang=js&"
export * from "./Shortlist.vue?vue&type=script&lang=js&"
import style0 from "./Shortlist.vue?vue&type=style&index=0&id=a8cb9cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cb9cce",
  null
  
)

export default component.exports